module.exports = "/static/assets/3eb016636cb3c47144c46e5fa67ad508.png";